// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1bM9S","title":"AfterBackImages_title__oAIqL","images":"AfterBackImages_images__2Nz6U"};